<template>
  <div class="card-box tilebox-three">
    <week-timetable :events="getEvents()" :day-range="[1, 2, 3, 4, 5]">
      <template slot-scope="props">
        <div
          class="table-cell-hover-no-opacity"
          :style="{
            backgroundColor: getCellColor(props.event),
            textAlign: 'center',
            width: '100%',
            height: '100%',
            opacity: props.event.meta.week_day === actualWeekDay && props.event.meta.slot_id === actualTimeSlot ? 1 : 0.5
          }">
          {{ getCellContent(props.event) }}
        </div>
      </template>
    </week-timetable>
    <div class="m-t-10 text-center">
      <span v-for="callType in callTypes">
        <span class="label label-pill"  :style="{ backgroundColor: callType.planning_color}">Type d'appel : {{ callType.name }}</span>&nbsp;
      </span>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import WeekTimetable from 'vue-timetable/components/WeekTimetable'

  export default {
    name: 'planning-widget',
    components: {WeekTimetable},
    props: ['planning'],
    computed: {
      callTypes () {
        return this.$store.getters['call_types/all']
      },
      actualWeekDay () {
        return moment().weekday()
      },
      actualTimeSlot () {
        return moment().hour() + (moment().minute() === 0 ? 'A' : 'B')
      }
    },
    methods: {
      getEvents () {
        let events = []

        for (let i = 1; i < 6; i++) {
          let day = moment().weekday(0).days(i).hours(7).minutes(0)

          for (let j = 0; j < 26; j++) {
            let date = {
              from: day.clone().add(j * 30, 'minutes'),
              to: day.clone().add(j * 30 + 30, 'minutes')
            }

            let meta = {
              slot_id: date.from.hour() + (date.from.minute() === 0 ? 'A' : 'B'),
              week_day: i - 1
            }

            events.push({date, meta})
          }
        }

        return events
      },
      getCellColor (event) {
        let slotValue = this.planning.time_slots[event.meta.week_day][event.meta.slot_id]

        if (slotValue === null) {
          return '#C0CCDA'
        } else {
          return this.callTypes.find(item => item.id === slotValue).planning_color
        }
      },
      getCellContent (event) {
        let slotValue = this.planning.time_slots[event.meta.week_day][event.meta.slot_id]

        if (slotValue === null) {
          return ''
        } else {
          return this.callTypes.find(item => item.id === slotValue).name
        }
      }
    }
  }
</script>

<style>
  .table-cell-hover-no-opacity:hover {
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// PlanningWidget.vue?ee31e65e